export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["في حالة نسيانك كلمة المرور للدخول إلى الحساب، يمكنك استعادتها من خلال الإجابة على السؤال السري."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["في هذا القسم يمكنك تغيير السؤال/الإجابة السرية."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["السؤال السري"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سؤالك:"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الإجابة:"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["السؤال السري"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سؤالك الخاص"])}
}